import { render, staticRenderFns } from "./SeeDoctorRecordsAdd.vue?vue&type=template&id=6c38657e&scoped=true&"
import script from "./SeeDoctorRecordsAdd.vue?vue&type=script&lang=js&"
export * from "./SeeDoctorRecordsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c38657e",
  null
  
)

export default component.exports